/**
 * How a price is written on an axis.
 *
 * <p>Its own module rather than a function inside `EChartComponent`: importing that file into a
 * test pulls echarts' ESM entry through jest, which does not transform it — the same wall the
 * replay-session tests hit through axios. A formatter with no dependencies should not need a
 * chart library mocked to be tested.
 */

/**
 * A PRICE, at the precision the price itself needs.
 *
 * <p>A fixed 2dp is wrong at both ends of this chart's range: it reads `0.00` for HPIL, which
 * last traded at 0.0001, and it throws away a tick of EURUSD at 1.0842. The magnitude picks the
 * decimals, so the label is exact for an index at 771.71 and for a pair at 1.08425 alike.
 *
 * @param {number} value the axis value under the cursor
 * @returns {string} the formatted price, or '' for anything that is not a finite number —
 *                   an axis label must never read `NaN` or `undefined`
 */
export function formatAxisPrice(value) {
  if (!Number.isFinite(value)) return '';
  const magnitude = Math.abs(value);
  const decimals = magnitude >= 100 ? 2
    : magnitude >= 1 ? 3
      : magnitude >= 0.01 ? 5 : 8;
  return value.toFixed(decimals);
}
